import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Helmet } from 'react-helmet';
import EmptyList from '../components/EmptyList';
import { EventsData } from '../data/EventsData';
import ImageSlider from '../components/ImageSlider';
import LinkLogo from "../assets/images/portfolio-link.jpg"
const EventsDetails = () => {
    const { EventName } = useParams();
    const [Event, setEvent] = useState(null);
    useEffect(() => {
        let Event = EventsData.find((Event) => Event.EventName === (EventName));
        if (Event) {
            setEvent(Event);
        }
    }, [EventName]);

    return (
        <div className='main-container'>
            {Event ? (
                <div>
                    <Helmet>
                        <title>Events | {Event.EventName}</title>
                    </Helmet>

                    <div className="section">
                        <div className="section-heading">
                            <h1>{Event.EventName}</h1>
                        </div>
                        <div className="grid-3-1">
                            <div>
                                <div className="sports-page-img">
                                    <ImageSlider images={Event.Images} />
                                </div>
                                <div className="sports-details">
                                    <p>{Event.Para1}</p><br />

                                    {Event.Para2 &&
                                        <p>{Event.Para2}</p>
                                    }
                                    {Event.ExternalLink &&
                                        <div className="sports-details-link">
                                            <a href={Event.ExternalLink} target="_blank" rel="noreferrer">
                                                {/* <img src={LinkLogo}/> */}
                                                <button className='card-item-btn'>Know More</button>
                                                </a>
                                        </div>
                                    }

                                </div>



                            </div>

                        </div>
                    </div>
                </div>



            ) : (
                <EmptyList />
            )}
        </div>
    )
}

export default EventsDetails